/*
 * Pokitrio-Redesign 2026: Verhalten des Desktop-Mega-Menues (snippets/pkt-mega-menu.liquid).
 *
 * - Hover (nur Maus): oeffnet nach kurzer Verzoegerung, schliesst verzoegert beim Verlassen.
 * - Fokus auf dem Hauptpunkt oeffnet das Panel, Tab laeuft durch seine Links; Fokus ausserhalb schliesst.
 * - Klick: Maus -> Link folgt (Panel ist schon offen); Touch/Stift -> erster Tipp oeffnet, zweiter folgt dem Link.
 *   Hauptpunkt ohne eigene Seite (button) schaltet um bzw. springt per Enter in das Panel.
 *   Zeigerart kommt aus dem Klick selbst (PointerEvent.pointerType, Tastatur: detail 0), sonst aus pointerdown.
 * - Pfeil runter auf dem Hauptpunkt: Panel oeffnen und ersten Link fokussieren.
 * - Escape schliesst und setzt den Fokus zurueck auf den Hauptpunkt.
 * - Plus im Panel legt in den Warenkorb (variant:add): Panel schliesst, der Warenkorb-Drawer ist frei.
 * - aria-expanded am Hauptpunkt, Abdunklung der Seite ([data-pkt-dim]) solange ein Panel offen ist.
 * - Theme-Editor: shopify:section:load/unload bindet die neu gerenderte Navigation neu (je Nav nur einmal,
 *   globale Listener nur einmal, auch wenn das Script erneut ausgefuehrt wird).
 * - Bewegung: Uebergaenge nur in CSS und nur bei prefers-reduced-motion: no-preference.
 */
(function () {
  'use strict';

  if (window.pktMegaMenu) {
    window.pktMegaMenu.init();
    return;
  }

  var desktop = window.matchMedia('(min-width: 1100px)');
  var OEFFNEN_MS = 140;
  var SCHLIESSEN_MS = 240;

  var offen = null;
  var tOeffnen = null;
  var tSchliessen = null;
  var unterdrueckeFokus = null;

  function dim() {
    return document.querySelector('[data-pkt-dim]');
  }

  function trigger(punkt) {
    return punkt.querySelector('.pkt-nav__link');
  }

  function ersterLink(punkt) {
    var p = punkt.querySelector('[data-pkt-panel]');
    return p ? p.querySelector('a[href], button:not([disabled])') : null;
  }

  function timerAus() {
    clearTimeout(tOeffnen);
    clearTimeout(tSchliessen);
  }

  function oeffne(punkt) {
    timerAus();
    if (!desktop.matches || offen === punkt || !punkt.isConnected) return;
    if (offen) schliesse(offen, true);
    punkt.classList.add('is-open');
    trigger(punkt).setAttribute('aria-expanded', 'true');
    var d = dim();
    if (d) d.classList.add('is-an');
    offen = punkt;
  }

  function schliesse(punkt, wechsel) {
    punkt = punkt || offen;
    if (!punkt) return;
    punkt.classList.remove('is-open');
    var t = trigger(punkt);
    if (t) t.setAttribute('aria-expanded', 'false');
    if (offen === punkt) offen = null;
    var d = dim();
    if (!wechsel && !offen && d) d.classList.remove('is-an');
  }

  function zeigerArt(e, gemerkt) {
    if (e.detail === 0) return '';                       // Tastatur (Enter/Leertaste)
    if (typeof e.pointerType === 'string' && e.pointerType) return e.pointerType;
    return gemerkt || 'mouse';
  }

  function bindePunkt(punkt) {
    var t = trigger(punkt);
    if (!t) return;
    var istButton = t.tagName === 'BUTTON';
    var zeiger = '';
    var warOffen = false;

    punkt.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      timerAus();
      // Beim Wechsel zwischen Hauptpunkten sofort, sonst mit Verzoegerung (kein Flackern beim Ueberfahren)
      tOeffnen = setTimeout(function () { oeffne(punkt); }, offen ? 0 : OEFFNEN_MS);
    });

    punkt.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(tOeffnen);
      tSchliessen = setTimeout(function () {
        if (offen === punkt) schliesse(punkt);
      }, SCHLIESSEN_MS);
    });

    t.addEventListener('pointerdown', function (e) {
      zeiger = e.pointerType;
      warOffen = punkt.classList.contains('is-open');
    });
    t.addEventListener('pointercancel', function () {
      zeiger = '';
      warOffen = false;
    });

    t.addEventListener('focus', function () {
      if (unterdrueckeFokus === t) {
        unterdrueckeFokus = null;
        return;
      }
      // Fokus per Touch/Stift entscheidet der Klick; Tastatur- und Maus-Fokus oeffnet
      if (zeiger === 'touch' || zeiger === 'pen') return;
      oeffne(punkt);
    });

    t.addEventListener('click', function (e) {
      var art = zeigerArt(e, zeiger);
      var vorher = warOffen;
      zeiger = '';
      warOffen = false;
      if (!desktop.matches) return;
      if (art === 'mouse') {
        if (istButton) {
          e.preventDefault();
          oeffne(punkt);
        }
        return; // Link: Panel ist offen, Klick fuehrt zur Kollektion
      }
      if (art === 'touch' || art === 'pen') {
        if (!vorher) {
          e.preventDefault();
          oeffne(punkt);
        } else if (istButton) {
          schliesse(punkt);
        }
        return;
      }
      // Tastatur: Link folgt; Button springt in das (offene) Panel
      if (istButton) {
        e.preventDefault();
        if (offen !== punkt) oeffne(punkt);
        var erster = ersterLink(punkt);
        if (erster) erster.focus();
      }
    });

    punkt.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        if (offen === punkt) {
          e.preventDefault();
          e.stopPropagation();
          schliesse(punkt);
          unterdrueckeFokus = t;
          t.focus();
          // Falls der Fokus schon auf dem Hauptpunkt war, feuert kein focus-Ereignis
          setTimeout(function () { if (unterdrueckeFokus === t) unterdrueckeFokus = null; }, 0);
        }
      } else if (e.key === 'ArrowDown' && e.target === t) {
        e.preventDefault();
        oeffne(punkt);
        var erster = ersterLink(punkt);
        if (erster) erster.focus();
      }
    });

    punkt.addEventListener('focusout', function (e) {
      var ziel = e.relatedTarget;
      if (ziel && punkt.contains(ziel)) return;
      // Klick auf eine nicht fokussierbare Stelle im Panel: Maus ist noch drin, offen lassen
      if (!ziel && punkt.matches(':hover')) return;
      if (offen === punkt) schliesse(punkt);
    });
  }

  function init() {
    // offenes Panel aus einer ersetzten Navigation vergessen
    if (offen && !offen.isConnected) offen = null;
    var d = dim();
    if (d && !offen) d.classList.remove('is-an');
    document.querySelectorAll('[data-pkt-nav]').forEach(function (nav) {
      if (nav.dataset.pktBereit) return;
      nav.dataset.pktBereit = '1';
      nav.querySelectorAll('[data-pkt-mega]').forEach(bindePunkt);
    });
  }

  // globale Listener: genau einmal
  document.addEventListener('click', function (e) {
    if (offen && e.target && e.target.closest && e.target.closest('[data-pkt-dim]')) schliesse();
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && offen) schliesse();
  });
  var beiWechsel = function () { if (!desktop.matches && offen) schliesse(); };
  if (desktop.addEventListener) desktop.addEventListener('change', beiWechsel);
  else if (desktop.addListener) desktop.addListener(beiWechsel);
  window.addEventListener('pageshow', function () { if (offen) schliesse(); });
  // Plus im Panel (Promo, Mini-Karten; assets/pkt-card.js meldet variant:add vom Plus): Panel zu, Warenkorb frei
  document.addEventListener('variant:add', function (e) {
    if (offen && e.target && e.target.nodeType === 1 && offen.contains(e.target)) schliesse();
  });

  // Theme-Editor
  document.addEventListener('shopify:section:unload', function (e) {
    if (offen && e.target && e.target.contains(offen)) {
      timerAus();
      offen = null;
      var d = dim();
      if (d) d.classList.remove('is-an');
    }
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var punkt = e.target && e.target.closest ? e.target.closest('[data-pkt-mega]') : null;
    if (punkt) oeffne(punkt);
  });
  document.addEventListener('shopify:block:deselect', function () { if (offen) schliesse(); });

  window.pktMegaMenu = { init: init };
  init();
})();
